// import React, { Suspense, useEffect } from "react";
// import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
// import { useAppSelector } from "./store/hooks";
// import { selectAccessToken } from "./store/slices/auth/selectors";
// import { CircularProgress, Container } from "@mui/material";
// import PublicRoute from "./components/routes/publicRoute/publicRoute";
// import ResponsiveLogin from "./views/Authentication/Login/ResponsiveLogin";
// import Header from "./views/Home/components/Header";
// import colors from "./constants/colors";

// const LoadingFallback = () => (
//   <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//     <CircularProgress />
//   </div>
// );

// // Lazy load components
// const ForgotPassword = React.lazy(async () => await import("./views/Authentication/ForgotPassword/ForgotPassword"));
// const ResetPassword = React.lazy(async () => await import("./views/Authentication/ResetPassword/ResetPassword"));
// const MagicLink = React.lazy(async () => await import("./views/Authentication/magicLink/magicLink"));
// const Home = React.lazy(async () => await import("./views/Home/Home"));
// const ContactUs = React.lazy(async () => await import("./views/ContactUs/ContactUs"));
// const Storages = React.lazy(async () => await import("./views/Storages/Storages"));
// const Requests = React.lazy(async () => await import("./views/Requests/Requests"));
// const Invoices = React.lazy(async () => await import("./views/Invoices/Invoices"));
// const BringBack = React.lazy(async () => await import("./views/BringBack/BringBack"));
// const AccountSettings = React.lazy(async () => await import("./views/AccountSettings/AccountSettings"));
// const Logout = React.lazy(async () => await import("./views/Logout/Logout"));
// const PayfortPay = React.lazy(async () => await import("./views/Payment/components/PayfortPay"));
// const PayfortPayNotLoggedIn = React.lazy(async () => await import("./views/Payment/components/PayfortPayNoLogin"));
// const Payment = React.lazy(async () => await import("./views/Payment/Payment"));
// const TapsPay = React.lazy(async () => await import("./views/Payment/components/TapsPay"));
// const PaymentStatus = React.lazy(async () => await import("./views/Payment/components/PaymentStatus"));
// const PaymentProcess = React.lazy(async () => await import("./views/Payment/components/PaymentProcess"));
// const CardPayfort = React.lazy(async () => await import("./views/Cards/CardPayfort"));
// const CardTap = React.lazy(async () => await import("./views/Cards/CardTap"));
// const CardProcess = React.lazy(async () => await import("./views/Cards/CardProcess"));
// const CardStatus = React.lazy(async () => await import("./views/Cards/CardStatus"));
// const CardTapSave = React.lazy(async () => await import("./views/Cards/CardTapSave"));
// const CardVerify = React.lazy(async () => await import("./views/Cards/CardVerify"));
// const PickupNote = React.lazy(async () => await import("./views/PickupNote/PickupNote"));
// const TapPayNoLogin = React.lazy(async () => await import("./views/Payment/components/TapsPayNoLogin"));
// const CardFailed = React.lazy(async () => await import("./views/Cards/CardFailed"));

// const AuthenticatedLayout = ({ children }: { children: React.ReactNode }) => {
//   return (
//     <>
//       <Header />
//       <Container
//         disableGutters
//         maxWidth={false}
//         sx={{
//           backgroundColor: colors.BLUE_100,
//           px: { xs: "1rem", md: "6rem" },
//           py: { xs: "1rem", md: "3rem" },
//         }}
//       >
//         {children}
//       </Container>
//     </>
//   );
// };

// const AppRouter = () => {
//   const navigate = useNavigate();
//   const accessToken = useAppSelector(selectAccessToken);
//   const location = useLocation();

//   useEffect(() => {
//     if (
//       !accessToken &&
//       location.pathname !== "/login" &&
//       location.pathname !== "/forgot-password" &&
//       location.pathname !== "/reset-password" &&
//       location.pathname !== "/magic-link" &&
//       location.pathname !== "/payment-status" &&
//       location.pathname !== "/card-status" &&
//       location.pathname !== "/card-verify" &&
//       location.pathname !== "/card-failed" &&
//       location.pathname !== "/pickup-note"
//     ) {
//       navigate("/login");
//     }
//   }, [accessToken, location.pathname, navigate]);

//   return (
//     <Suspense fallback={<LoadingFallback />}>
//       <Routes>
//         <Route
//           path="/login"
//           element={
//             <PublicRoute>
//               <ResponsiveLogin />
//             </PublicRoute>
//           }
//         />
        
//         <Route path="/forgot-password" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <PublicRoute>
//               <ForgotPassword />
//             </PublicRoute>
//           </Suspense>
//         } />
//         <Route path="/reset-password" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <PublicRoute>
//               <ResetPassword />
//             </PublicRoute>
//           </Suspense>
//         } />
//         <Route path="/magic-link" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <MagicLink />
//           </Suspense>
//         } />
//         <Route path="/home" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <Home />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/contact-us" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <ContactUs />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/storages" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <Storages />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/requests/*" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <Requests />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/requests/:requestId/note" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <PickupNote />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/invoices" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <Invoices />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/bring-back" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <BringBack />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/account-settings" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <AccountSettings />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/logout" element={
//           <Suspense fallback={<LoadingFallback />}>
//             <AuthenticatedLayout>
//               <Logout />
//             </AuthenticatedLayout>
//           </Suspense>
//         } />
//         <Route path="/" element={
//           accessToken ? <Navigate to="/storages" /> : <Navigate to="/login" />
//         } />
//       </Routes>
//     </Suspense>
//   );
// };

// const HomeRouter = () => {
//   return (
//     <Suspense>
//       <Routes>
//         <Route path="/payment" element={<Payment />} />
//         <Route path="/payfort-pay" element={<PayfortPay />} />
//         <Route path="/payfort-pay-no-login" element={<PayfortPayNotLoggedIn />} />
//         <Route path="/taps-pay" element={<TapsPay />} />
//         <Route path="/payment-status" element={<PaymentStatus />} />
//         <Route path="/payment-process" element={<PaymentProcess />} />
//         <Route path="/card-payfort" element={<CardPayfort />} />
//         <Route path="/card-tap" element={<CardTap />} />
//         <Route path="/card-process" element={<CardProcess />} />
//         <Route path="/card-status" element={<CardStatus />} />
//         <Route path="/card-tap-save" element={<CardTapSave />} />
//         <Route path="/card-verify" element={<CardVerify />} />
//         <Route path="/pickup-note" element={<PickupNote />} />
//         <Route path="/tap-pay-no-login" element={<TapPayNoLogin />} />
//         <Route path="/card-failed" element={<CardFailed />} />
//       </Routes>
//     </Suspense>
//   );
// };

// export { AppRouter, HomeRouter };

import React, { Suspense, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useAppSelector } from "./store/hooks";
import { selectAccessToken } from "./store/slices/auth/selectors";
import { isAccountsRole, isOperationsRole } from "./utils/permissions";

const Login = React.lazy(
  async () => await import("./views/Authentication/Login/Login")
);
const ForgotPassword = React.lazy(
  async () =>
    await import("./views/Authentication/ForgotPassword/ForgotPassword")
);
const ResetPassword = React.lazy(
  async () => await import("./views/Authentication/ResetPassword/ResetPassword")
);
const MagicLink = React.lazy(
  async () => await import("./views/Authentication/magicLink/magicLink")
);
const Home = React.lazy(async () => await import("./views/Home/Home"));
const ContactUs = React.lazy(
  async () => await import("./views/ContactUs/ContactUs")
);
const IntegrationSteps = React.lazy(
  async () => await import("./views/IntegrationSteps/IntegrationSteps")
);
const Storages = React.lazy(
  async () => await import("./views/Storages/Storages")
);
const Requests = React.lazy(
  async () => await import("./views/Requests/Requests")
);
const Orders = React.lazy(
  async () => await import("./views/Orders/Orders")
);
const Invoices = React.lazy(
  async () => await import("./views/Invoices/Invoices")
);

const Payments = React.lazy(
  async () => await import("./views/Payments")
);
const BringBack = React.lazy(
  async () => await import("./views/BringBack/BringBack")
);
const AccountSettings = React.lazy(
  async () => await import("./views/AccountSettings/AccountSettings")
);
const Manage = React.lazy(
  async () => await import("./views/Manage/Manage")
);
const Logout = React.lazy(async () => await import("./views/Logout/Logout"));
const PayfortPay = React.lazy(
  async () => await import("./views/Payment/components/PayfortPay")
);
const PayfortPayNotLoggedIn = React.lazy(
  async () => await import("./views/Payment/components/PayfortPayNoLogin")
);

const Payment = React.lazy(async () => await import("./views/Payment/Payment"));

const TapsPay = React.lazy(
  async () => await import("./views/Payment/components/TapsPay")
);

const PaymentStatus = React.lazy(
  async () => await import("./views/Payment/components/PaymentStatus")
);

const PaymentProcess = React.lazy(
  async () => await import("./views/Payment/components/PaymentProcess")
);

const CardPayfort = React.lazy(
  async () => await import("./views/Cards/CardPayfort")
);

const CardTap = React.lazy(async () => await import("./views/Cards/CardTap"));

const CardProcess = React.lazy(
  async () => await import("./views/Cards/CardProcess")
);

const CardStatus = React.lazy(
  async () => await import("./views/Cards/CardStatus")
);

const CardTapSave = React.lazy(
  async () => await import("./views/Cards/CardTapSave")
);

const CardVerify = React.lazy(
  async () => await import("./views/Cards/CardVerify")
);

const PickupNote = React.lazy(
  async () => await import("./views/PickupNote/PickupNote")
);

const TapPayNoLogin = React.lazy(
  async () => await import("./views/Payment/components/TapsPayNoLogin")
);

const CardFailed = React.lazy(
  async () => await import("./views/Cards/CardFailed")
);

// Consumer acquisition funnel (public, pre-login) — ported from webapp v1.
const Signup = React.lazy(async () => await import("./views/Funnel/Signup"));
const Quote = React.lazy(async () => await import("./views/Funnel/Quote"));
const QuoteStatus = React.lazy(
  async () => await import("./views/Funnel/QuoteStatus")
);
const OrderStorage = React.lazy(
  async () => await import("./views/Funnel/OrderStorage")
);
const OrderAppointment = React.lazy(
  async () => await import("./views/Funnel/OrderAppointment")
);
const OrderConfirm = React.lazy(
  async () => await import("./views/Funnel/OrderConfirm")
);
const OrderStatusPage = React.lazy(
  async () => await import("./views/Funnel/OrderStatus")
);
const OrderAction = React.lazy(
  async () => await import("./views/Funnel/OrderAction")
);
const NotLoggedInNewOrder = React.lazy(
  async () => await import("./views/Funnel/NotLoggedInNewOrder")
);
const Lead = React.lazy(async () => await import("./views/Funnel/Lead"));
const Survey = React.lazy(async () => await import("./views/Funnel/Survey"));
const Offer = React.lazy(async () => await import("./views/Funnel/Offer"));

const RoleGuard = ({
  children,
  forbiddenFor,
  redirectTo,
}: {
  children: JSX.Element;
  forbiddenFor: (accessToken?: string) => boolean;
  redirectTo: string;
}) => {
  const accessToken = useAppSelector(selectAccessToken);
  if (forbiddenFor(accessToken)) return <Navigate to={redirectTo} replace />;
  return children;
};

export const AppRouter = () => {
  const navigate = useNavigate();
  const accessToken = useAppSelector(selectAccessToken);
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Public paths that must remain reachable without an access token.
    // Note: "/order/" (funnel) is public, while "/orders" (authed list) is not.
    const PUBLIC_PREFIXES = [
      "/login",
      "/logout",
      "/forgot-password",
      "/reset-password",
      "/magic-link",
      "/signup",
      "/quote",
      "/order",
      "/lead",
      "/survey",
      "/offer",
    ];
    const isPublicPath =
      PUBLIC_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`)) ||
      path.includes("/payment");

    if (!accessToken && !isPublicPath) {
      navigate("/login");
    } else if (path === "/login" && accessToken) {
      navigate("/");
    }
  }, [location]);
  return (
    <Suspense>
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/magic-link" element={<MagicLink />} />
        {/* Consumer acquisition funnel (public) — ported from webapp v1 */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/quote/status" element={<QuoteStatus />} />
        <Route path="/order/storage" element={<OrderStorage />} />
        <Route path="/order/details" element={<OrderAppointment />} />
        <Route path="/order/confirm" element={<OrderConfirm />} />
        <Route path="/order/status" element={<OrderStatusPage />} />
        <Route path="/order/action/:orderId" element={<OrderAction />} />
        <Route path="/order/contact" element={<NotLoggedInNewOrder />} />
        <Route path="/lead/:leadId" element={<Lead />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/offer/:countryId" element={<Offer />} />
        {!accessToken && (
          <>
            <Route
              path="/payment/tap/:userId/:amount"
              element={<TapPayNoLogin />}
            />
            <Route
              path="/payment/payfort/:userId/:amount"
              element={<PayfortPayNotLoggedIn />}
            />
          </>
        )}
      </Routes>
    </Suspense>
  );
};

export const HomeRouter = () => {
  return (
    <Suspense>
      <Routes>
        {/* Operations-only routes: accounts users are redirected to /payment */}
        <Route path="/" element={
          <RoleGuard forbiddenFor={isAccountsRole} redirectTo="/payment">
            <Storages />
          </RoleGuard>
        } />
        <Route path="/bring-back" element={
          <RoleGuard forbiddenFor={isAccountsRole} redirectTo="/payment">
            <BringBack />
          </RoleGuard>
        } />
        <Route path="/orders" element={
          <RoleGuard forbiddenFor={isAccountsRole} redirectTo="/payment">
            <Orders />
          </RoleGuard>
        } />
        <Route path="/requests" element={
          <RoleGuard forbiddenFor={isAccountsRole} redirectTo="/payment">
            <Requests />
          </RoleGuard>
        } />
        <Route path="/requests/:requestId/note" element={
          <RoleGuard forbiddenFor={isAccountsRole} redirectTo="/payment">
            <PickupNote />
          </RoleGuard>
        } />
        <Route path="/integration-steps" element={
          <RoleGuard forbiddenFor={isAccountsRole} redirectTo="/payment">
            <IntegrationSteps />
          </RoleGuard>
        } />

        {/* Accounts-only routes: operations users are redirected to / */}
        <Route path="/payment" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <Payment />
          </RoleGuard>
        } />
        <Route path="/payment/tap/:userId/:amount" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <TapsPay />
          </RoleGuard>
        } />
        <Route path="/payment/payfort/:userId/:amount" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <PayfortPay />
          </RoleGuard>
        } />
        <Route path="/payment/:mode/process" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <PaymentProcess />
          </RoleGuard>
        } />
        <Route path="/payment/status/:paymentId" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <PaymentStatus />
          </RoleGuard>
        } />
        <Route path="/card/failed" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardFailed />
          </RoleGuard>
        } />
        <Route path="/card/payfort" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardPayfort />
          </RoleGuard>
        } />
        <Route path="/card/tap" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardTap />
          </RoleGuard>
        } />
        <Route path="/card/:mode/process" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardProcess />
          </RoleGuard>
        } />
        <Route path="/card/status/:cardId" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardStatus />
          </RoleGuard>
        } />
        <Route path="card/tap/save" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardTapSave />
          </RoleGuard>
        } />
        <Route path="/card/verify" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <CardVerify />
          </RoleGuard>
        } />
        <Route path="/invoices" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <Invoices />
          </RoleGuard>
        } />
        <Route path="/payments-history" element={
          <RoleGuard forbiddenFor={isOperationsRole} redirectTo="/">
            <Payments />
          </RoleGuard>
        } />
        <Route path="/contact-us" element={
            <ContactUs />
        } />

        {/* Accessible to all roles */}
        <Route path="/logout" element={<Logout />} />
        <Route path="/account-settings" element={<AccountSettings />} />
        <Route path="/manage" element={<Manage />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Suspense>
  );
};
